import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useNewWebsite } from "context/client/new_website";

import DetailsCard from "components/DetailsCard";
import SubscriptionPlan from "./components/SubscriptionPlan";
import Widget from "../../Widget";
import NavMobile from "../../NavMobile";

import useResponsive from "libs/helpers/useResponsive";
import choosePlanSchema from "libs/validations/new_website_form/choosePlanSchema";

const mainClass = "new-website-content__choose-plan";

const ChoosePlan = () => {
  const { t } = useTranslation();
  const { min } = useResponsive();

  const { website, change_plan_mode, form_data, nextStep, prevStep } =
    useNewWebsite();

  const onSubmit = (values) => {
    nextStep(values);
  };

  return (
    <Formik
      initialValues={{
        website: !!change_plan_mode
          ? website?.website
          : form_data?.website || "",
        plan: form_data?.plan || null,
        billed_type: form_data?.billed_type || "monthly",
      }}
      validationSchema={choosePlanSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({ values }) => (
        <Form className={mainClass} autoComplete="off">
          <DetailsCard
            {...(min.lg
              ? { title: t("Back"), backAction: () => prevStep() }
              : {})}
            resetOnMobile
          >
            <div className={`${mainClass}__row`}>
              <div className={`${mainClass}__column`}>
                <SubscriptionPlan
                  current={{
                    plan: website?.subscription?.price_id,
                    billed_type:
                      website?.subscription?.contract_period?.toLowerCase(),
                  }}
                />
              </div>
              {min.lg ? (
                <div className={`${mainClass}__column`}>
                  <Widget isNextDisabled={!values?.plan} />
                </div>
              ) : (
                <NavMobile
                  isNextDisabled={!values?.plan}
                  onBack={() => prevStep()}
                />
              )}
            </div>
          </DetailsCard>
        </Form>
      )}
    </Formik>
  );
};

export default ChoosePlan;
